// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_2c5r9","popoverWrapper":"_2c5r9","root":"_1iv-M"};